import $ from 'jquery';
import 'bootstrap/js/dist/collapse'
import '../src/js/menu';
import '../src/js/parallax';
import '../src/js/collapse';

$(function() {
    // go!
});
